module.exports = __webpack_public_path__ + "static/media/group-6-copy-12-2.cffefbea.svg";